<template>
	<router-view></router-view>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="scss">
	html, body {
		font-family: 'Noto Sans JP2', sans-serif;
	}

	a {
		color: inherit;
	}

	[contenteditable] {
		outline: 0 solid transparent;
	}

</style>
